import { format } from "date-fns";
import { IUser } from '../models/IUser';

export const DatePicker_onFormatDate = (date?: Date): string => 
{
  if(date === undefined) return '';

  return format(date, 'dd-MM-yyyy');    
};

export const CreateAuthHeader = () : any => {
  // return authorization header with basic auth credentials
  let cached = sessionStorage.getItem('uhrevind_token') + "";
  let user : IUser = JSON.parse(cached) as IUser;

  if (user && user.token) {        
      return { 'Authorization': 'Bearer ' + user.token, 'Content-Type': 'application/json' };
  } else {
      return {};
  }
}

export const CreateAuthHeaderAsFormData = () : any => {
  // return authorization header with basic auth credentials
  let cached = sessionStorage.getItem('uhrevind_token') + "";
  let user : IUser = JSON.parse(cached) as IUser;

  if (user && user.token) {
      return { 'Authorization': 'Bearer ' + user.token, 'Content-Type': 'multipart/form-data' };
  } else {
      return {};
  }
}

const SignOutLocally = (): void => {
    // Clear session storage and redirect to login
    sessionStorage.removeItem('uhrevind_token');
    sessionStorage.removeItem('uhrevind_currentGuild');
    sessionStorage.removeItem('uhrevind_currentGuild_stats');

    window.location.href = "/Logget-ud";
}

export const HandleUnauthorized = (response: Response): void => {
    if (response.status === 401) {
        SignOutLocally();
    }
}

const GetCurrentGuildId = (): string | undefined => {
    const guild = sessionStorage.getItem('uhrevind_currentGuild');
    if (guild) {
        return JSON.parse(guild)?.id;
    }

    // Brugere med kun ét laug har ikke altid gemt et valgt laug
    const user = JSON.parse(sessionStorage.getItem('uhrevind_token') + "") as IUser | null;
    return user?.guilds?.length === 1 ? user.guilds[0].id : undefined;
}

// Deles mellem samtidige kald, så lauget kun vælges igen én gang
let reselectGuildPromise: Promise<boolean> | null = null;

const ReselectCurrentGuild = (): Promise<boolean> => {
    if (!reselectGuildPromise) {
        reselectGuildPromise = (async () => {
            try {
                const guildId = GetCurrentGuildId();
                if (!guildId) {
                    return false;
                }

                const response = await fetch('api/application', {
                    method: 'POST',
                    headers: CreateAuthHeader(),
                    body: JSON.stringify({ GuildID: guildId })
                });

                // Ugyldig token eller adgangen til lauget er fjernet - log ud, så laug hentes på ny ved login
                if (response.status === 401 || response.status === 403) {
                    SignOutLocally();
                }

                return response.ok;
            } finally {
                reselectGuildPromise = null;
            }
        })();
    }

    return reselectGuildPromise;
}

const IsGuildNotSelected = async (response: Response): Promise<boolean> => {
    if (response.status !== 409) {
        return false;
    }

    try {
        const body = await response.clone().json();
        return body?.code === "GuildNotSelected";
    } catch {
        return false;
    }
}

export const AuthenticatedFetch = async (input: RequestInfo | URL, init?: RequestInit): Promise<Response> => {
    let response = await fetch(input, init);

    // Laug-sessionen på serveren er udløbet eller ugyldig - vælg lauget igen og prøv én gang mere
    if (await IsGuildNotSelected(response) && await ReselectCurrentGuild()) {
        response = await fetch(input, init);
    }

    // Automatically handle 401 responses
    if (response.status === 401) {
        HandleUnauthorized(response);
    }

    return response;
}

export const RemoveLastNCharactersFromString = (str: string, n: number): string => {
  return str.substring(0, str.length - n);
}

export const FormatCurrency = (x: number, seperator?: string): string => {
  if(x == null || x == undefined || isNaN(x)) return "0,00";
  
  if (seperator != null) {
      //eslint-disable-next-line
      return x.toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".").replace(/\.([^\.]*)$/g, seperator + '$1');
  }

  return x.toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
}

export const SaveFileAs = async (window: any, filename: string, description: string, content: string | Blob, accept : any) => {
  if(accept === undefined)
  {
    accept = {'text/plain': ['.csv']};
  }    

  const handle = await window.showSaveFilePicker({
    suggestedName: filename,
    types: [{
        description: description,
        accept: accept
    }],
    });

    let blob : Blob;
    if(content instanceof Blob)
    {
      blob = content as Blob;
    } else
    {
      blob = new Blob([content]);
    }
    
    const writableStream = await handle.createWritable();
    await writableStream.write(blob);
    await writableStream.close();
}